export const testId = 'parcel-details';
